export default {
  "signIn":"sign in",
  "signUp":"sign up",
  "orders":"orders",
  "myOrders":"My Orders",
  "logout":"logout",
  "now":"now",
  "all":"all",
  "confirmOrder":"Confirm Order",
  "total":"total",
  "toPay":"pay",
  "submit":"submit",
  "email":"email",
  "password":"password",
  "confirmPassword":"confirm password",
  "forgotPassword":"forgot password",
  "captcha":"captcha",
  "required":"required",
  "again":"Please check your entries and try again.",
  "expire":"expire",
  "error":"error",
  "number":"number",
  "buy":"buy",
  "empty":"empty",
  "loading":"loading",
  "success":"success",
  "orderNo":"orderNo",
  "unpaid":"unpaid",
  "waitingForDelivery":"waiting for delivery",
  "deliver":"deliver",
  "logOnAgain":"please log on again",
  "postage":"Postage",
  "price":"Price",
  "address":"Address",
  "remarks":"Remarks",
  "inputAddress":"Address",
  "logistics":"Logistics information",
  "close":"close",
};